import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

export const [ActivityTypes, ActivityTypeSchema, ActivityTypeEnum] =
  EnumBuilder(
    'advance_payment_status_changed',
    'agreement_terms_accepted',
    'comment_created',
    'post_production_review_brand_feedback_submitted',
    'post_production_review_maker_proposal_submitted',
    'pre_production_review_brand_feedback_submitted',
    'pre_production_review_maker_proposal_submitted',
    'project_bid_accepted',
    'project_bid_rejected',
    'project_bidding_closed',
    'project_bidding_opened',
    'project_bidding_successful',
    'project_bidding_unsuccessful',
    'project_closed',
    'project_created',
    'project_file_added',
    'project_offer_expired',
    'project_offer_pending',
    'project_offers_sent',
    'project_service_added',
    'project_status_changed'
  )

export type ActivityType = ZodInfer<typeof ActivityTypeSchema>
